import { useFeaturedVideos } from '@bpm-web-app/swr-hooks';
import { useMemo, useEffect } from 'react';
import CardCarousel from '../shared/card-carousel/card-carousel';
import { GhostComponent } from '../shared';
import { VideoCard } from '../shared/card/video-card/video-card';

export interface FeaturedTutortialsProps {
    title?: string;
    isDataLoaded?: boolean;
    setIsDataLoaded?: (loaded: boolean) => void;
}

export function FeaturedTutortials({ title, isDataLoaded, setIsDataLoaded }: FeaturedTutortialsProps) {
    const { data, isLoading } = useFeaturedVideos();
    const searchFeaturedTutortials = data?.data;

    useEffect(() => {
        if (setIsDataLoaded) {
            if (isLoading === false && searchFeaturedTutortials) {
                setIsDataLoaded(true);
            } else {
                setIsDataLoaded(false);
            }
        }
    }, [isLoading, searchFeaturedTutortials, setIsDataLoaded]);

    const shouldDisplayGhostLoading = useMemo(() => isDataLoaded === false || isLoading, [isDataLoaded, isLoading]);

    if (shouldDisplayGhostLoading) {
        return (<GhostComponent type="cards" elementsCount={10} title={title || 'Featured Tutorials'} cardSize="wide" />);
    }

    return (
        <div>
            <CardCarousel title={title || 'Featured Tutorials'} awlaysShowSeeMore seeMorePath="/academy">
                {searchFeaturedTutortials &&
                    searchFeaturedTutortials.map((item) => (
                        <VideoCard
                            key={item.id}
                            video={item} />
                    ))}
            </CardCarousel>
        </div>
    );
}

export default FeaturedTutortials;
